import { Validator } from '@vista-digital/validator';
import { defaultEventImageCdnOptions, eventImageCdnOptionsValidator } from './cdn-options';
import { defaultEventImageConfig, eventImageConfigValidator } from './config';
export const defaultEventImageProps = {
    cdnOptions: defaultEventImageCdnOptions,
    config: defaultEventImageConfig
};
export const eventImagePropsValidator = Validator.object({
    cdnOptions: eventImageCdnOptionsValidator,
    config: eventImageConfigValidator
});
